export class AssessmentStatus {
  static notStarted = 0;
  static inProgress = 1;
  static completed = 2;
  static finalized = 3;
  static reviewed = 4;
  static disabled = 5;
}
